import { useMemo } from 'react';

import { useIdentityRoles } from '@/js/libs/use-auth';

import { POST_ENDPOINTS } from '../constants';

type LogoutCallback = () => void;

const handlePostLogout: LogoutCallback = () => {
  window.location.assign(import.meta.env.VITE_POST_LOGOUT_ENDPOINT);
};

const usePostLogoutCallback = (): LogoutCallback | undefined => {
  const { POSTADMANAGER, POSTNETZ } = useIdentityRoles();

  return useMemo<LogoutCallback | undefined>(() => {
    const isPostUser = POSTADMANAGER || POSTNETZ;
    const isPostUrl = POST_ENDPOINTS.includes(window.location.host);

    if (isPostUser && isPostUrl) {
      return handlePostLogout;
    }

    return undefined;
  }, [POSTADMANAGER, POSTNETZ]);
};

export default usePostLogoutCallback;
